export const GREEN_FONT = 'text-green-500';
export const RED_FONT = 'text-red-500';
export const ELECTRICITY_COLOR = '#CC0033';
export const WATER_COLOR = '#0066FF';
